import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WalterLoader from '../../shared/WalterLoader';
import './actionPlanV2.css';

const MODULES = [
  {
    key: 'hydroEfficientEquipment',
    label: 'Équipements tertiaires hydro-économes',
    description: "Chiffrez les économies d'eau réalisables via mousseurs, réducteurs de débit douche et écobags.",
    route: 'hydro-efficient-equipment',
    enabled: true,
  },
  {
    key: 'rainwater',
    label: "Récupération d'eau de pluie",
    description: 'Chiffrez le potentiel de récupération et de réutilisation des eaux pluviales.',
    route: 'rainwater-harvesting',
    enabled: true,
  },
  {
    key: 'reut',
    label: 'Réutilisation des eaux grises (REUT)',
    description: 'Chiffrez le potentiel de réutilisation des eaux usées traitées.',
    route: 'reut',
    enabled: true,
  },
];

const ClientActionPlanV2 = () => {
  const navigate = useNavigate();
  const { client_id, building_id } = useParams();

  const [building, setBuilding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!building_id) return;
    fetch(`${process.env.REACT_APP_API_URL}/get_building/${building_id}`)
      .then(r => { if (!r.ok) throw new Error("Erreur lors de la récupération du bâtiment."); return r.json(); })
      .then(data => { setBuilding(data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [building_id]);

  if (loading) return (
    <div className="centered-spinner-dashboard">
      <WalterLoader />
    </div>
  );
  if (error) return <p>Erreur : {error}</p>;

  const waterPriceMissing = !building?.global_water_data?.water_price;

  return (
    <div className="apv2-page">
      <div className="apv2-module-header">
        <button type="button" className="back-button" onClick={() => navigate(`/client/${client_id}/${building_id}`)}>
          ← Tableau de bord
        </button>
        <h1 className="apv2-module-title">Modules de chiffrage</h1>
      </div>

      {waterPriceMissing && (
        <div className="apv2-warning-banner">
          Aucun prix de l'eau renseigné pour ce bâtiment — les économies en € ne pourront pas être calculées tant qu'il n'est pas renseigné.
        </div>
      )}

      <div className="apv2-module-grid">
        {MODULES.map(mod => (
          <div
            key={mod.key}
            className={`apv2-module-card ${mod.enabled ? '' : 'apv2-module-card--disabled'}`}
            onClick={() => mod.enabled && navigate(`/client/${client_id}/${building_id}/action_plan_v2/${mod.route}`)}
          >
            <h2 className="apv2-module-card-title">{mod.label}</h2>
            <p className="apv2-module-card-desc">{mod.description}</p>
            {mod.enabled ? (
              <span className="apv2-module-card-cta">Ouvrir →</span>
            ) : (
              <span className="apv2-module-card-badge">Bientôt disponible</span>
            )}
          </div>
        ))}
      </div>

      <div className="apv2-global-summary">
        <h2>Résumé global</h2>
        <p>À venir — l'agrégation des économies calculées par chaque module sera affichée ici.</p>
      </div>
    </div>
  );
};

export default ClientActionPlanV2;
